import * as Html from "../../util/Html.ts";
export {init}
Html.registerWidget('widget/form/onoff-checkbox',{init:init})

function init(elem){
  var input = elem.find('input');
  elem.on('click',function(){
    if(!input.prop("disabled")){
      input.prop("checked",!input.prop("checked")).trigger('change');
    }
  });
  input.on('ui-change change',function(){
    elem.toggleClass('fw-onoff-disabled',input.prop("disabled"));
    elem.toggleClass('fw-onoff-on',input.prop("checked"));
  })
}